<div class="row">
	<div class="col-12 py-5">
		<h4>Dashboard</h4>
    <p class="text-gray">Welcome {{userService.userInfo.firstName}} {{userService.userInfo.lastName}}</p>
	</div>
</div>

<div class="row">
  <div class="col-md-3 col-sm-6 col-6 equel-grid">
    <div class="grid">
      <div class="grid-body">
        <h4 class="mb-4">{{deviceService.devicesOnlineCount}} Devices Online</h4>
      </div>
    </div>
  </div>

  <div class="col-md-3 col-sm-6 col-6 equel-grid">
    <div class="grid">
      <div class="grid-body">
        <h4 class="mb-4">{{deviceService.deviceCellularCount}} Cellular Devices</h4>
      </div>
    </div>
  </div>

  <div class="col-md-12 col-sm-12 col-12 equel-grid">
    <div class="googleMapContainer grid">
      <div class="grid-body">
        <h4 class="mb-4">Locations</h4>
        <app-map></app-map>
      </div>
    </div>
  </div>

  <div class="col-12 equel-grid">
    <div class="grid table-responsive">
      <h4 class="mb4 poorCellTitle">Poor Cellular Connection</h4>
      <table class="table table-stretched">
        <thead>
          <th>Device</th>
          <th>Code</th>
          <th>Connection</th>
        </thead>
        <tbody>
          <tr *ngFor="let device of devices">
            <td>{{device.name}}</td>
            <td>{{device.code}}</td>
            <td><img *ngIf="device.rssi_value" class="signal-icon" src="/assets/images/signal-{{device.rssi_value}}.png" /></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

</div>
